import _ from 'lodash';
import React from 'react';
import { AllocationBillableTypeFilter, YesNoFilter } from '~/components';
import { ClientFiltersBar, MemberFiltersBar, ProjectFiltersBar, ResourceFiltersBar } from '~/components/filters';
import FiltersBarContainer from '../../components/FiltersBar';

export default function FiltersBar({ params, onFilterChange }) {
  return (
    <FiltersBarContainer>
      <YesNoFilter
        icon="filter"
        placeholder="Only projects with allocations"
        value={params.onlyAllocatedProjects ? 'yes' : 'no'}
        onChange={({ target: { value } }) => onFilterChange({ onlyAllocatedProjects: value === 'yes' })}
      />

      <ClientFiltersBar filters={params} onChange={onFilterChange} />

      <ProjectFiltersBar filters={params} onChange={onFilterChange} />

      <MemberFiltersBar filters={params} onChange={onFilterChange} />

      <ResourceFiltersBar filters={params} onChange={onFilterChange} />

      {!_.isEmpty(params.allocationBillableTypes) && (
        <AllocationBillableTypeFilter
          value={params.allocationBillableTypes}
          onChange={({ target: { value } }) => onFilterChange({ allocationBillableTypes: value })}
        />
      )}
    </FiltersBarContainer>
  );
}
